
import ogPagesMixins from '@/mixins/ogPagesMixins'
const LIMIT = 10
// Настройки SEO полей head
const SEO = {
  TITLE: 'Видеоразборы | Мегасреда',
  DESCRIPTION: 'Видеоразборы на мегасреде',
  OG_IMAGE: {
    url: 'https://megasreda.ru/img/broadcasts_ogg.jpg',
    urlVk: 'https://megasreda.ru/img/broadcasts_ogg-vk.jpg',
    urlTw: 'https://megasreda.ru/img/broadcasts_ogg.jpg',
    type: 'image/jpeg',
    width: 1200,
    height: 630,
  },
}
export default {
  mixins: [ogPagesMixins],
  scrollToTop: true,
  data() {
    return {
      products: [],
      productsCount: 0,
      page: this.$route.query?.page ? this.$route.query.page : 1,
    }
  },
  async fetch() {
    await this.fetchProducts()
  },
  computed: {
    seoTitle() {
      return SEO.TITLE
    },
    seoDescription() {
      return SEO.DESCRIPTION
    },
    seoImage() {
      return SEO.OG_IMAGE
    },

    pageCount() {
      return Math.ceil(this.productsCount / LIMIT)
    },

    productsOffset() {
      return (this.page - 1) * LIMIT
    },
  },
  watch: {
    $route() {
      if (!this.$route.query?.page) {
        this.page = 1
        this.products = []
        this.$router.push({
          query: {},
        })
        this.fetchProducts()
      }
    },
  },
  methods: {
    paginateClick(page) {
      this.products = []
      if (page === 1) {
        this.$router.push({
          query: {},
        })
      } else {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: this.page,
          },
        })
        this.fetchProducts()
      }
      this.$scrollTo('body')
    },
    loadMore() {
      this.page++
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.page,
        },
      })
      this.fetchProducts()
    },
    setFormatFilter(format) {
      this.format = format
      this.products = []
      this.fetchProducts()
    },
    async fetchProducts() {
      try {
        const { products, countAllPublishedProducts } = await this.$axios.$get(
          '/advertisements/broadcasts/past',
          {
            params: {
              limit: LIMIT,
              offset: this.productsOffset,
              format: '64abdf43516f606cb102468d',
            },
          }
        )

        this.productsCount = countAllPublishedProducts
        this.products = this.products?.length
          ? this.products.concat(products)
          : products
      } catch (error) {
        console.log(error)
      }
    },

    updateProduct() {
      this.products = []
      this.fetchProducts()
      this.$emit('update-broadcast')
    },
    removeProduct() {
      this.products = []
      this.fetchProducts()
      this.$emit('remove-broadcast')
    },
  },
}
